import request from '@/utils/request.js';

//获取基本信息
export function companyInfo() {
    return request.get('/pc/info/query');
};

//获取导航栏信息
export function getNavData() {
    return request.get('/pc/nav_bar/query');
};

//获取首页模板
export function getHomePageData() {
    return request.get('/pc/index_set/get_home');
};

//根据ID获取页面模板
export function getPageData(id) {
    return request.get(`/pc/index_set/${id}`);
};

//FAQ分类列表
export function getFAQTypeList() {
    return request.get('/pc/faq_center/type_list');
};

//FAQ数据列表
export function getFAQList(params) {
    return request.get('/pc/faq_center/list',params);
};

//FAQ列表详情
export function getFAQDetail(id) {
    return request.get(`pc/faq_center/${id}`);
};

//咨询中心列表
export function getConsultList(params) {
    return request.get('/pc/cou_center/list',params);
};

//咨询中心列表详情
export function getConsultListDetail(id) {
    return request.get(`/pc/cou_center/${id}`);
};

//获取支付二维码
export function postPayCode(data) {
    return request.post(`/pc/pay/getPayCode`,data);
};

//提交订单
export function postOrderSubmit(data) {
    return request.post(`/pc/order/submitOrder`,data);
};


//获取支付类型
export function getPayTypeList() {
    return request.get(`/pc/pay_way/list/pc`);
};


//获取支付类型
export function getOrderInfo(orderNo) {
    return request.get(`/pc/order/${orderNo}`);
};
